import { GIFT_AMCS, GiftAmc } from "../constants";

export function useGiftAmcs(): GiftAmc[] {
  return GIFT_AMCS;
}
